export default __webpack_public_path__ + "static/media/report_21.754d3d98.png";